import { render } from "./Heading.vue?vue&type=template&id=852f412a"
import script from "./Heading.vue?vue&type=script&lang=js"
export * from "./Heading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/wpcm/fields/Heading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "852f412a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('852f412a', __exports__)) {
    api.reload('852f412a', __exports__)
  }
  
  module.hot.accept("./Heading.vue?vue&type=template&id=852f412a", () => {
    api.rerender('852f412a', render)
  })

}


export default __exports__